module.exports = __webpack_public_path__ + "static/media/Heart.26758195.png";